import { create } from 'zustand';
import { createWithEqualityFn } from 'zustand/traditional';

export const createZustandShallowStore = createWithEqualityFn;
export const createZustandNormalStore = create;
